<!-- HEADER BOTONERA -->
<form [formGroup]='formDetails' (ngSubmit)="buscar(true)">
  <div class="card mt-2 mb-2 wow">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        display: flex;
        align-items: center;
      ">
        <h4>Buscar descuentos</h4>
        <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect (click)="abrirModalAgregarDescuento()">
          Agregar
        </button>
      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col" style="
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 2%;
          ">
            <strong>Buscar por productos: </strong>
            <!-- Material inline 1 -->
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="codigoProducto" class="form-control" placeholder="" required
                  #codigoProducto formControlName="codigoProducto" />
                <label for="codigoProducto">Código de producto</label>

                <div *ngIf="
                formDetails.get('codigoProducto').invalid &&
                (formDetails.get('codigoProducto').dirty ||
                formDetails.get('codigoProducto').touched)
              ">
                  <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('required')">Ingrese código de producto
                  </mdb-error>
                  <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('min')">Código de producto debe ser
                    mayor a 0 </mdb-error>
                  <!-- <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('max')">Descuento máximo
                      debe ser menor a 100 </mdb-error> -->
                </div>
              </div>
            </div>
            <div class="col d-flex" style="display: flex; align-items: center;">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="abrirModalSeleccionarProducto()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>

              <h6 class="text-info" *ngIf="productosMultiplesSeleccionados?.length > 1" style="display: contents;">
                <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                  (click)="abrirModalSeleccionarProductosSeleccionados()">
                  ({{productosMultiplesSeleccionados.length | numerico}}) Seleccionados
                </button>
              </h6>
              <h6 class="text-info" *ngIf="productosMultiplesSeleccionados?.length === 1" style="display: contents;">
                {{ productosMultiplesSeleccionados[0].descripcion }}
              </h6>
            </div>

          </div>

          <div class="col">
            <div class="row">
              <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha inicio'" required
                    formControlName='fechaInicio'>
                  </mdb-date-picker>
                  <label for="fechaInicio">Desde:</label>
                </div>
              </div>


              <div class="col" style="
               font-size: 14px;
               font-weight: bold;
               padding-top:1%">
                <span>Estados:</span>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" mdbInput id="EstActivoMax" [value]="RO_EstadoActivoMax"
                    formControlName="estadoActMax" checked>
                  <label class="form-check-label" for="EstActivoMax">
                    Activo
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" mdbInput id="EstInactivoMax"
                    [value]="RO_EstadoInactivoMax" formControlName="estadoActMax">
                  <label class="form-check-label" for="EstInactivoMax">
                    Inactivo
                  </label>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted  filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6;">
      <button mdbBtn type="button" color="info" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <button mdbBtn type="submit" size="sm" color="secondary" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- LISTADO -->
<div class="card mb-2 wow">
  <div class="card-body" *ngIf="listaDescuentos">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <th scope="col">Descripción</th>
          <th scope="col">Desde</th>
          <th scope="col">Hasta</th>
          <th scope="col">Estado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="100%" style="text-align: center">
            <mdb-spinner spinnerColor="blue"></mdb-spinner>
          </td>
        </tr>
        <tr *ngIf="!loading && listaDescuentos?.length === 0">
          <td colspan="100%" style="text-align: center">
            No se encontró información
          </td>
        </tr>
        <tr *ngFor="let descuento of listaDescuentos; trackBy: trackByDescuentoCodigo">
          <td>{{ descuento.descripcion }}</td>
          <td>{{ descuento.fecha_inicio | fecha }}</td>
          <td>{{ descuento.fecha_termino | fecha }}</td>
          <td>
            <mdb-badge pill="true" success="true" *ngIf='descuento.activado'>Activo</mdb-badge>

            <mdb-badge pill="true" danger="true" *ngIf='!descuento.activado'>Inactivo</mdb-badge>

          </td>
          <td>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
              placement="right" (click)="ver(descuento)">
              <mdb-icon fas icon="eye"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Editar" placement="right" (click)="editar(descuento)"
              [disabled]="!descuento.permiteEdicion || !descuento.activado">
              <mdb-icon fas icon="pen"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Duplicar" placement="right" (click)="confirmDuplicar(descuento.codigo)">
              <mdb-icon far icon="copy"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Desactivar" placement="right" (click)="confirmDesactivar(descuento)"
              [disabled]="!descuento.permiteEdicion">
              <mdb-icon fas icon="ban"></mdb-icon>
            </button>
          </td>
        </tr>
      </tbody>
      <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="listaDescuentos?.length > 0"></app-pagination>
    </table>
  </div>
</div>

<!-- MODAL Agregar Descuento -->
<app-modal-addedit-descuentos-topes [permiteUnidadNegocio]="permiteUnidadNegocio" (onSuccess)="onDescuentoSaved()">
</app-modal-addedit-descuentos-topes>

<app-modal-seleccionar-producto [origen]="MODAL_SEL_PROD_DESCUENTO" (onSelect)="onProductoSeleccionado($event)"
  [showFiltroActivoInactivo]="false" (onNotFound)="onProductoNoEncontrado()" showSelectAll="true"
  (onSelectAll)="onMultiplesProductosSeleccionados($event)" (onRemoteQuery)="getProductsByUnidadNegocio($event)"
  paginateLocally="true" (onUncheckProducto)="uncheckProducto($event)">
</app-modal-seleccionar-producto>

<app-modal-confirm [title]="modalConfirmTitle" [contentText]="modalConfirmContent">
</app-modal-confirm>

<app-modal-show-clientes>
</app-modal-show-clientes>
